import { gql } from 'graphql-request';
import { graphQLApi } from 'utils/Api';
import { GetPreviewResponse, OvertimeGetPreviewInput } from '../types';

const getPreviewQuery = gql`
  query OvertimeGetPreview($input: OvertimeGetPreviewInput!) {
    overtimeGetPreview(input: $input) {
      code
      success
      message
      data {
        entries {
          formulaCardId
          formulaCardName
          computedAmount
        }
      }
    }
  }
`;

const getPreview = (queryVariables: { input: OvertimeGetPreviewInput }) => {
  return graphQLApi<GetPreviewResponse, { input: OvertimeGetPreviewInput }>({
    query: getPreviewQuery,
    queryVariables,
  });
};

export default getPreview;
